module.exports = __webpack_public_path__ + "media/81.9ca71ef7.wav";